import axios, { type AxiosInstance } from 'axios';
import { queryClient } from '../lib/queryClient';

const client: AxiosInstance = axios.create({
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

client.interceptors.response.use(
  (response) => {
    const body = response.data;
    if (body && typeof body === 'object' && 'data' in body) {
      response.data =
        'meta' in body ? { data: body.data, meta: body.meta } : body.data;
    }
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      queryClient.setQueryData(['auth', 'me'], null);
    }
    return Promise.reject(error);
  }
);

export default client;
